module.exports = __webpack_public_path__ + "img/UHF-LS-50.580e1d68.webp";